"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function NutanixGreyOutline(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M11.357 9.715l3.35 3.011h-2.703l-1.998-1.798 1.35-1.213zm-.008-.86a.552.552 0 00-.365.141l-1.685 1.516a.563.563 0 00-.04.793l.04.04 2.25 2.025c.106.09.24.142.377.142h3.373a.556.556 0 00.554-.558.564.564 0 00-.185-.42l-3.934-3.538a.566.566 0 00-.358-.141h-.027zM14.706 3.082l-3.35 3.012-1.346-1.213 1.998-1.799h2.698zm.585-.785h-3.365a.583.583 0 00-.377.141l-2.25 2.027a.559.559 0 00-.04.789.43.43 0 00.04.043l1.685 1.516a.555.555 0 00.75 0l3.934-3.538a.564.564 0 00-.377-.978zM3.991 3.082l5.357 4.823-5.357 4.821H1.295L6.006 8.49l.648-.585-.648-.586-4.712-4.237H3.99zm.083-.785H.709a.558.558 0 00-.562.558c0 .16.067.314.185.42l5.148 4.63-5.148 4.63a.563.563 0 00.377.977h3.365a.575.575 0 00.377-.142l5.607-5.05a.555.555 0 000-.832l-5.607-5.05a.575.575 0 00-.377-.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    fillRule: "evenodd",
    d: "M0 2.855c0-.393.319-.705.709-.705h3.365c.172 0 .345.064.475.178v.001l5.604 5.046a.703.703 0 01.004 1.056L4.55 13.48h-.001a.723.723 0 01-.475.18H.709a.71.71 0 01-.476-1.234v-.001l5.027-4.52-5.027-4.52A.712.712 0 010 2.854zm.709-.41a.41.41 0 00-.414.41.417.417 0 00.135.31l5.27 4.74-5.269 4.738a.417.417 0 00-.029.586.409.409 0 00.307.136h3.365a.428.428 0 00.279-.104l5.608-5.05a.408.408 0 00.032-.58l-.005-.005-.004-.006a.08.08 0 00-.014-.014l-.01-.008-5.607-5.05a.43.43 0 00-.279-.104H.709zm10.745-.119a.73.73 0 01.472-.176h3.365c.203 0 .392.084.526.233a.71.71 0 01-.05 1v.001l-3.934 3.538a.702.702 0 01-.949 0l-1.69-1.52V5.4c-.01-.01-.03-.03-.047-.051a.706.706 0 01.053-.993l2.254-2.03zm.192.223L9.398 4.573a.412.412 0 00-.03.582l.005.005.005.006a.565.565 0 00.023.025l1.683 1.514a.408.408 0 00.55 0l.001-.002 3.934-3.537a.417.417 0 00.029-.586.409.409 0 00-.307-.136h-3.365c-.1 0-.2.037-.28.105zM.91 2.935h3.138l5.52 4.97-5.52 4.969H.91L5.907 8.38l.527-.475-.527-.476L.91 2.935zm.768.295l4.426 3.98.77.695-.77.694-4.426 3.98h2.257l5.193-4.674L3.935 3.23H1.678zm10.274-.295h3.138l-3.733 3.357L9.79 4.881l2.162-1.946zm.113.295L10.23 4.88l1.127 1.015 2.965-2.666h-2.257zm-1.179 5.656a.7.7 0 01.463-.178h.032c.168.005.326.069.45.178h.001l3.935 3.539c.15.134.233.328.233.53a.704.704 0 01-.7.704h-3.374a.73.73 0 01-.472-.176l-.004-.003-2.255-2.031v-.001h-.002v-.002l-.002-.001-.001-.002-.002-.001-.001-.002-.002-.001-.001-.002h-.001l-.001-.002-.002-.001-.001-.002h-.001l-.004-.005-.002-.001-.001-.001v-.001H9.17l-.001-.002-.002-.001-.001-.001v-.001h-.001l-.001-.002-.002-.001-.001-.002-.002-.001-.001-.002h-.001l-.001-.002-.006-.005a.71.71 0 01.05-1v-.002l1.685-1.515.001-.001zm.195.22l-1.683 1.515a.417.417 0 00-.031.583l.001.001.001.001.002.002.001.001.002.002.001.001.001.002h.001l.002.002.001.001.001.002.004.003.001.002h.001v.001h.002v.001l.001.001.002.002v.001h.002v.001l.001.001.002.002.001.001.002.002 2.246 2.023c.08.068.18.105.28.105h3.372a.41.41 0 00.408-.41c0-.121-.05-.234-.136-.311l-3.934-3.537a.42.42 0 00-.262-.105h-.025a.407.407 0 00-.268.104zm.276.41l3.733 3.358h-3.142l-2.162-1.946 1.57-1.411zm-1.13 1.412l1.13-1.015 2.965 2.666h-2.261l-1.835-1.65z",
    clipRule: "evenodd"
  }));
}

NutanixGreyOutline.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
NutanixGreyOutline.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = NutanixGreyOutline;
exports["default"] = _default;